<template>
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <div
      class="d-flex flex-column justify-center align-center"
      :style="{
        'text-align': 'center',
        width: '70%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <h2>Jenis QR</h2>
      <p>Pilih jenis QR yang ingin digunakan</p>

      <v-row align="center" class="full-width">
        <v-select
          :items="qrItems"
          label="QR Type"
          solo
          v-model="jenisQr"
          class="full-width"
          :error-messages="jenisQRErrors"
          @input="$v.jenisQr.$touch()"
          @blur="$v.jenisQr.$touch()"
        />
      </v-row>

      <template v-if="isQrAPI">
        <InterfaceField ref="interfaceField" />

        <p class="subtitle">Pilih Versi Client</p>
        <v-row align="center" class="mt-2 full-width">
          <v-select
            :items="qrVersionItems"
            label="Pilih Versi Client"
            solo
            class="full-width"
            v-model="clientVersion"
            :error-messages="clientVersionErrors"
            @input="$v.clientVersion.$touch()"
            @blur="$v.clientVersion.$touch()"
          />
        </v-row>
      </template>
      
      <v-row align="center" class="mt-6">
        <v-btn small color="warning" dark @click="prevStep" :style="{ margin: '2px' }">
          <v-icon dark left>mdi-arrow-left</v-icon>Kembali
        </v-btn>
        <v-btn small color="primary" dark @click="nextStep" :style="{ margin: '2px' }">
          Lanjut
          <v-icon dark right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { dataQrType, listClientVersion } from '../../store/params';
import InterfaceField from './fields/interface/InterfaceField.vue';

export default {
  name: 'step3',
  components: {
    InterfaceField
  },
  mixins: [validationMixin],

  validations: {
    jenisQr: { required },
    clientVersion: {
      required() {
        return this.jenisQr === '2' ? !!this.clientVersion : true;
      }
    }
  },
  data() {
    return {
      dataQrType,
      qrVersionItems: listClientVersion,
    };
  },
  computed: {
    isQrAPI() {
      return this.jenisQr === '2';
    },
    clientVersionErrors() {
      const errors = [];
      if (!this.$v.clientVersion.$dirty) return errors;
      if (!this.$v.clientVersion.required) errors.push('Client Version is required');
      return errors;
    },
    jenisQRErrors() {
      const errors = [];
      if (!this.$v.jenisQr.$dirty) return errors;
      if (!this.$v.jenisQr.required) errors.push('QR Type is required');
      return errors;
    },

    jenisQr: {
      set(val) {
        this.$store.commit('register/setQrType', val);
      },
      get() {
        return this.$store.state.register.data.qrType;
      },
    },

    clientVersion: {
      set(val) {
        this.$store.commit('register/setClientVersion', val);
      },
      get() {
        return this.$store.state.register.data.clientVersion;
      },
    },

    qrItems() {
      return this.dataQrType;
    },
  },

  watch: {
    jenisQr(val) {
      if (!val || val === '1') {
        this.$store.commit('register/setAccountType', '1');
        this.$store.commit('register/setNeedInterface', false);
        this.$store.commit('register/setSelectedInterfaces', []);
        if (this.$refs.interfaceField) {
          this.$refs.interfaceField.resetValidation();
        }
      }
    }
  },

  methods: {
    prevStep() {
      this.$store.commit('register/setStep', 2);
    },
    nextStep() {
      this.$v.$touch();
      
      if (this.$refs.interfaceField) {
        this.$refs.interfaceField.touchValidation();
      }

      if (!this.$v.$invalid) {
        const interfaceFieldValid = !this.$refs.interfaceField || !this.$refs.interfaceField.$v.$invalid;
        
        if (interfaceFieldValid) {
          this.$store.commit('register/setStep', 4);
        }
      }
    },
  },
};
</script>

<style scoped>
.full-width { width: 80%; }
.subtitle { margin: 14px 0 6px; }
</style>
